module.exports = __webpack_public_path__ + "img/brand-dan.44d37812.svg";